import { IconFont, Text } from '@lighthouse/bui'
import type { OtherPlatformType } from '@lighthouse/shared'
import React from 'react'
import styled from 'styled-components'

import { otherPlatformNameMap } from '@/containers/OtherPlatforms/constant'
import { openInstallOtherPlatform } from '@/containers/OtherPlatforms/OtherPlatformEvent'

export const SCxContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 12px;
    margin-top: 87px;
`

export const SCxIcon = styled(IconFont)`
    color: var(--color-gray-400);
`

export const SCxTitle = styled.div`
    color: var(--color-gray-500);
    font-size: 14px;
    line-height: 22px;
`
export const SCxSubTitle = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    color: var(--color-purple-500);
    font-size: 14px;
    line-height: 16px;
    cursor: pointer;
`

type UnitNoAuthProps = {
    type: OtherPlatformType
}
export const UnitNoAuth: React.FC<UnitNoAuthProps> = ({ type }) => {
    return (
        <SCxContainer>
            <SCxIcon type="Tool" size={40} />
            <SCxTitle>需要先安装“{otherPlatformNameMap[type]}”插件</SCxTitle>
            <SCxSubTitle onClick={() => openInstallOtherPlatform(type)}>
                <Text>立即安装</Text>
                <SCxIcon type="ArrowRightSmall" color="var(--color-purple-500)" size={16} />
            </SCxSubTitle>
        </SCxContainer>
    )
}
